import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoginService } from 'src/app/service/login.service';
import { ftlEasyConfigV2 } from 'src/environments/environment';


@Component({
    selector: 'app-ftl-easy',
    template: ''
})
export class FtlEasyComponent implements OnInit {
  // constructor(
  //   private redirectService: RedirectService,
  //   private route: ActivatedRoute
  // ) {
  //   this.route.queryParams.subscribe(async (params) => {
  //     const inApp = params['inApp'];
  //     if (inApp) {
  //       ftlEasyConfig.redirectUri = ftlEasyConfig.redirectUri + '?inApp=true';
  //     }
  //   });
  // }
  // ngOnInit(): void {
  //   this.redirectService.redirect(ftlEasyConfig.redirectUri);
  // }
  constructor(
    private loginService: LoginService,
    private route: ActivatedRoute
  ) {
    this.route.queryParams.subscribe(async (params) => {
      const inApp = params['inApp'];
      if (inApp) {
        ftlEasyConfigV2.redirectUri = ftlEasyConfigV2.redirectUri + '&inApp=true';
      }

    });
  }

  ngOnInit(): void {
    this.loginService.login(ftlEasyConfigV2);
  }
}
